import {ChangeDetectionStrategy, Component, Inject, signal, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {StaffMember} from 'src/app/types/StaffMember';

@Component({
  selector: 'app-staff-member-details-modal',
  templateUrl: './staff-member-details-modal.component.html',
  styleUrls: ['./staff-member-details-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffMemberDetailsModal {
  public staffMember = signal<StaffMember>(null);

  constructor(
    private dialogRef: MatDialogRef<StaffMemberDetailsModal>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.staffMember.set(data);
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
